


























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { toDataPicker } from '@/utils/dataHora'
import moment from 'moment'
import _ from 'lodash'

@Component
export default class ModalRegraGestaoIncluir extends Vue {
  $refs: {
    form: any
  }

  formRules: any = {
    valid: true,
    prestadorGestorId: [(v: any) => !!v || 'Campo obrigatório'],
    gestorId: [(v: any) => !!v || 'Campo obrigatório'],
    grupoRepasseId: [(v: any) => !!v || 'Campo obrigatório'],
    fontePagadoraFiltroId: [(v: any) => !!v || 'Campo obrigatório'],
    localExecucaoId: [(v: any) => !!v || 'Campo obrigatório'],
    tipoCalculo: [(v: any) => !!v || 'Campo obrigatório'],
    valor: [(v: any) => (v !== null && v !== undefined && v !== '') || 'Campo obrigatório'],
    vigenciaInicio: [(v: any) => !!v || 'Campo obrigatório'],
  }

  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false
  initialDataLoaded: boolean = false

  loadAddRegraCalculo: boolean = false
  searchPrestador: any = ''
  searchProfissional: any = ''
  filtroProfissional: string = ''
  profissionalName: string = ''
  loadingPrestadorFilter: boolean = false
  loadingProfissionalFilter: boolean = false

  gestoresDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getGestores(param), 500)
  prestadoresDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getPrestadoresRepasse({ filtro: param, limite: 20 }), 500)

  get loadingAddRegraCalculo() { return this.loadAddRegraCalculo }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculo = value }

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGestao }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGestao', value }) }

  get mode() { return this.getRegrasDeCalculoStore.modeModalRegraValoresFixos }

  get centroDeCusto() { return this.getRegrasDeCalculoStore.centroDeCusto }
  get transacaoFinanceira() { return this.getRegrasDeCalculoStore.transacaoFinanceira }
  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  get profissionaisExecutantes() { return this.getRegrasDeCalculoStore.profissionaisExecutantes }
  get prestadores() { return this.getRegrasDeCalculoStore.prestadoresRepasse }
  set prestadores(value: any) { this.getRegrasDeCalculoStore.setPrestadoresRepasse(value) }
  get gruposRepasse() { return this.getRegrasDeCalculoStore.gruposRepasse }
  get subGruposRepasse() { return this.getRegrasDeCalculoStore.subGruposRepasse }
  get gestores() { return this.getRegrasDeCalculoStore.gestores }
  get localExecucaoById() { return this.getRegrasDeCalculoStore.localExecucaoById }

  get getMenuInicioVigencia() { return this.menuInicioVigencia }
  set getMenuInicioVigencia(value: boolean) { this.menuInicioVigencia = value }
  get getMenuFimVigencia() { return this.menuFimVigencia }
  set getMenuFimVigencia(value: boolean) { this.menuFimVigencia = value }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    console.error('Data inválida:', vigencia)
    return ''
  }

  get vigenciaInicio() { return toDataPicker(this.getRegrasDeCalculoStore.regraGestaoItem.vigenciaInicio) }
  set vigenciaInicio(value: string | null) { this.setVigencia('vigenciaInicio', value) }

  get vigenciaFim() { return toDataPicker(this.getRegrasDeCalculoStore.regraGestaoItem.vigenciaFim) }
  set vigenciaFim(value: string | null) { this.setVigencia('vigenciaFim', value) }

  setVigencia(campo: string, value: string | null) {
    this.getRegrasDeCalculoStore.setRegraGestaoItem({
      ...this.getRegrasDeCalculoStore.regraGestaoItem,
      [campo]: value,
    })
  }

  get formattedInicioVigencia() {
    return this.vigenciaInicio ? this.formatDate(this.vigenciaInicio) : ''
  }

  set formattedInicioVigencia(value: string) {
    if (!value) {
      this.vigenciaInicio = null
    }
  }

  get formattedFimVigencia() {
    return this.vigenciaFim ? this.formatDate(this.vigenciaFim) : ''
  }

  set formattedFimVigencia(value: string) {
    if (!value) {
      this.vigenciaFim = null
    }
  }

  async addValorFixo() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.form.validate()) {
      this.loadingAddRegraCalculo = false
      return
    }
    const paginacaoAtual = this.getRegrasDeCalculoStore.paginacaoRegrasValorFixo
    const request = await this.getRegrasDeCalculoStore.addRegraGestao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.getRegrasDeCalculoStore.clearRegraGestao()
    this.getRegrasDeCalculoStore.getRegrasGestao(paginacaoAtual)
    this.closeModal()
  }

  changeProfissionalExecutante(value: any) {
    if (value) {
      this.profissionalName = value.nome
      this.getRegrasDeCalculoStore.regraGestaoItem.gestorId = value.userId
    } else {
      this.profissionalName = ''
    }
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getRegrasDeCalculoStore.setProfissionaisExecutantes([])
      return
    }
    
    if(this.profissionalName === val){
      return
    } else {
      this.filtroProfissional = ''
    }
    
    this.loadingProfissionalFilter = true
    
    if(this.gestoresDebounced) await this.gestoresDebounced(val)
    this.loadingProfissionalFilter = false
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (!val || val.length < 3) {
      this.getRegrasDeCalculoStore.setPrestadoresRepasse([])
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  @Watch('getRegrasDeCalculoStore.regraGestaoItem.fontePagadoraFiltroId', { immediate: true })
  @Watch('getRegrasDeCalculoStore.regraGestaoItem.filtrarPorLocal')
  onFiltroChange() {
    const { fontePagadoraFiltroId, filtrarPorLocal } = this.getRegrasDeCalculoStore.regraGestaoItem
    if (fontePagadoraFiltroId || !filtrarPorLocal) {
      this.getRegrasDeCalculoStore.getLocalExecucaoByFontePagadora()
    }
  }

  closeModal() {
    this.showModal = false
    this.getRegrasDeCalculoStore.clearRegraGestao()
    this.$refs.form.resetValidation()
  }

  @Watch('showModal')
  async onShowModalChange(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraGestao()
      this.getRegrasDeCalculoStore.setGestores([])
    } else {
      if(this.getRegrasDeCalculoStore.regraGestaoItem.gestorId){
        this.profissionalName = this.getRegrasDeCalculoStore.regraGestaoItem.nomeGestor
        
        this.getRegrasDeCalculoStore.setGestores([{
          userId: this.getRegrasDeCalculoStore.regraGestaoItem.gestorId,
          nome: this.getRegrasDeCalculoStore.regraGestaoItem.nomeGestor,
        }])
      }
      
      if (!this.initialDataLoaded) {
        await this.getRegrasDeCalculoStore.getCentroDeCusto()
        await this.getRegrasDeCalculoStore.getGruposRepasse()
        await this.getRegrasDeCalculoStore.getTransacaoFinanceiraFixo()
        this.initialDataLoaded = true
      }
   
      this.prestadores = [{
        userId: this.getRegrasDeCalculoStore.regraGestaoItem.prestadorGestorId,
        nome: this.getRegrasDeCalculoStore.regraGestaoItem.nomePrestadorGestor,
      }]
    }
  }
}
